'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parse = require('./parse');

Object.defineProperty(exports, 'parse', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_parse).default;
  }
});

var _lookup = require('./lookup');

Object.defineProperty(exports, 'lookup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_lookup).default;
  }
});

var _navigatorLanguages = require('./navigatorLanguages');

Object.defineProperty(exports, 'navigatorLanguages', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_navigatorLanguages).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}